export enum ElectronicDocumentTypeEnum {
  invoice = 1,
  note = 2,
  documentSupport = 3
}